import PaginationController, {
  SHARED_RESULTS_WRAPPER_ID,
} from '@/utils/Controllers/Listing/PaginationController';
import { checkWishlistIcon } from '@/kenwood/Controllers/KENWishlistController';

const bindBrandEventsOnPage = () => {
  checkWishlistIcon();
  const resultsWrapper = document.getElementById(SHARED_RESULTS_WRAPPER_ID);
  const plpPromoWrapper = document.getElementById('js-ken-plp__promo-banner');
  if (resultsWrapper && !plpPromoWrapper) {
    resultsWrapper.classList.remove('--has-promo-banner');
    resultsWrapper.classList.remove('--first-load');
  }
};

export default () => {
  PaginationController({ bindBrandEventsOnPage });
};
